import { render } from "./PageKullanicilar.vue?vue&type=template&id=2dcd071a"
import script from "./PageKullanicilar.vue?vue&type=script&lang=js"
export * from "./PageKullanicilar.vue?vue&type=script&lang=js"
script.render = render

export default script